import { EffectComposer, N8AO, SMAA as Smaa } from '@react-three/postprocessing';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

/**
 * Post-processing effects (AO + SMAA) driven by graphicsSettings.aoQuality.
 * Drop inside any R3F Canvas that should share consistent post-processing behaviour.
 */
export const ScenePostProcessing = () => {
    const { aoQuality, multisampling } = usePlacementStore(
        useShallow((state) => ({
            aoQuality: state.graphicsSettings.aoQuality,
            multisampling: state.graphicsSettings.multisampling,
        }))
    );

    const aoIntensity = aoQuality === 'off' ? 0 : 2;
    const aoActiveQuality = aoQuality === 'off' ? 'performance' : aoQuality as 'performance' | 'high' | 'ultra';

    return (
        <EffectComposer multisampling={multisampling}>
            {aoQuality !== 'off'
                ? <>
                    <N8AO
                        aoRadius={0.8}
                        distanceFalloff={0.5}
                        intensity={aoIntensity}
                        quality={aoActiveQuality}
                    />
                    <Smaa />
                </>
                : <></>
            }
        </EffectComposer>
    );
};
